import { NotesConfig } from './notes.abstract.config';

export const notesConfig: NotesConfig = {
  privileges: {
    job: {
      notes: 'web:jobs-notes',
      hiringManager: 'hiring-manager',
    },
  },
};
